import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    BaseLeaseCategory, ContractCurrency, ProductType,
} from 'app/enums/label.enums'

import {
    RateCardsTabs,
} from 'app/enums/domain.enums'

import requests from 'app/requests/RateCard/RateCard.requests'
import {
    BaseLeaseTable,
} from './BaseLease.types'

const config: SkyNetTableTab<keyof BaseLeaseTable> = {
    name: 'Standard Base Lease',
    url: RateCardsTabs.BaseLease,
    customUrl: requests.baseLeaseFilterRequest().url,
    defaultTab: true,
    fields: [
        {
            name: 'baseLeaseCategory',
            componentName: 'EnumValue',
            allowedValuesEnum: BaseLeaseCategory,
            labelKey: 'BaseLease.baseLeaseCategory',
        },
        {
            name: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
            labelKey: 'BaseLease.productType',
        },
        {
            name: 'currency',
            componentName: 'EnumValue',
            allowedValuesEnum: ContractCurrency,
            labelKey: 'BaseLease.currency',
        },
        {
            name: 'baseFeeValue',
            alignTextRight: true,
            labelKey: 'BaseLease.base',
        },
        {
            name: 'additionalPeriodOne',
            alignTextRight: true,
            labelKey: 'BaseLease.additionalPeriod1',
        },
        {
            name: 'additionalPeriodTwo',
            alignTextRight: true,
            labelKey: 'BaseLease.additionalPeriod2',
        },
        {
            name: 'additionalPeriodThree',
            alignTextRight: true,
            labelKey: 'BaseLease.additionalPeriod3',
        },
    ],
}

export default config
